import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { SlCheckbox } from '@shoelace-style/shoelace';

/**
 * This piece of code is related to the way material implemented their shoelace styled components.
 * Please refer to https://github.com/ngx-formly/ngx-formly/blob/main/src/ui/material/multicheckbox/src/multicheckbox.type.ts
 */
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  },
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> implements OnInit {

  ngOnInit() {
    if (this.props.required) {
      this.formControl.setValidators([this.requireAtLeastOneChecked()]);
      this.formControl.updateValueAndValidity();
    }
  }

  getOptions(): any[] {
    // It's safe to assume `prop.options` is type `any[]` since we pass in the values via API to the prop options
    return this.props.options as any[];
  }

  // Validator to ensure at least one checkbox is checked if required
  requireAtLeastOneChecked(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const hasValue = Object.values(value || {}).some((checked) => checked === true);

      return hasValue ? null : { required: true };
    };
  }

  onChange(value: any, event: Event) {
    const target = event.target as SlCheckbox;
    const checked = target.checked;
    this.formControl.markAsDirty();

    this.formControl.patchValue({ ...this.formControl.value, [value]: checked });

    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();
  }

  isDisabled(option: any): string | null {
    const disabled = this.formControl.disabled || !!option.disabled;
    if (disabled) {
      return "checked"
    }
    return null;
  }
}
